import {ALERT_TYPES, showAlert} from "./alert";
import { handleError } from './handleError.js';
import {api} from "./apiService";
import {normalizePhoneNumber} from "./utils";

export function initRegisterPage() {
    const registerForm = document.getElementById('register-form');
    if (!registerForm) return;

    const nameInput = document.getElementById('name');
    const usernameInput = document.getElementById('username');
    const passwordInput = document.getElementById('password');
    const confirmPasswordInput = document.getElementById('confirmPassword');
    const emailInput = document.getElementById('email');
    const phoneInput = document.getElementById('phone');
    const agreementInput = document.getElementById('agreement');
    const registerButton = document.getElementById('register-button');
    const alertId = "register-alert";

    registerForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        registerButton.disabled = true;
        registerButton.innerHTML = 'در حال ثبت‌نام...';

        try {
            const userData = {
                name: nameInput.value,
                username: usernameInput.value,
                password: passwordInput.value,
                email: emailInput.value,
                phone: normalizePhoneNumber(phoneInput.value)
            };

            if (!userData.name || !userData.username || !userData.password || !confirmPasswordInput.value || !userData.email || !userData.phone) {
                showAlert(alertId, ALERT_TYPES.WARN, "خطا!", "لطفاً همه‌ی موراد را وارد کن.");
                resetButtonState();
                return;
            }

            if (!agreementInput.checked) {
                showAlert(alertId, ALERT_TYPES.WARN, "خطا!", "باید شرایط استفاده را بپذیری.")
                resetButtonState();
                return;
            }

            if (passwordInput.value !== confirmPasswordInput.value) {
                showAlert(alertId, ALERT_TYPES.WARN, "خطا!", "رمز ورود و تایید رمز مثه هم نیست.")
                resetButtonState();
                return;
            }

            await api.userRegister(userData);

            showAlert(alertId, ALERT_TYPES.OK, "حله!", "ثبت نام شدی و الآن می‌تونی وارد بشی.")

            setTimeout(() => {window.location.href = '/login';}, 3000);

        } catch (error) {
            handleError(error, alertId);
            resetButtonState();
        }
    });

    function resetButtonState() {
        registerButton.disabled = false;
        registerButton.innerHTML = 'ثبت‌نام';
    }
}
